import PageShell from "./PageShell";
import About from "../components/landing/About";
import Anniversary from "../components/landing/Anniversary";

const AboutPage = () => (
  <PageShell title="About">
    <About />
    <Anniversary />
  </PageShell>
);

export default AboutPage;
